<template>
  <i18n-t
    keypath="landingpage/extension/product/mod_space"
    tag="p"
    class="mb-2"
  >
    <template #units>
      <span class="text-brand">
        {{ extension.units }} {{ extension.unitType || 'GB' }}
      </span>
    </template>
  </i18n-t>
</template>

<script setup lang="ts">
import type { StrapiOrderConfigurationExtension } from '#variant/apollo/types/types';

defineProps<{
  extension: StrapiOrderConfigurationExtension;
}>();
</script>
